import { TFunction } from "next-i18next";
import { UTSLocale } from "@smile2impress/attraction-constants";

import { PageContentProps } from "content/content.types";

const getPageData = (t: TFunction, { locale }: PageContentProps) => ({
    locale,
    tableOfContentsTitle: t("blog:content"),
    shareTitle: t("blog:shareArticle"),
    ctaAlt1: t("blog:ctaAlt1"),
    ctaAlt2: t("blog:ctaAlt2"),
    ctaAlt3: t("blog:ctaAlt3"),
    ctaAlt4: t("blog:ctaAlt4"),
});

export default (locale: UTSLocale) => {
    switch (locale) {
        case UTSLocale.FRANCE_FR:
        case UTSLocale.ITALY_IT:
        case UTSLocale.PORTUGAL_PT:
        case UTSLocale.SPAIN_ES:
        case UTSLocale.GB_EN:
        case UTSLocale.US_EN:
        case UTSLocale.UKRAINE_UK:
        case UTSLocale.NL_NL:
        case UTSLocale.GERMANY_DE:
        case UTSLocale.SWEDEN_SE:
            return getPageData;
        default:
            return () => null;
    }
};
